__turbopack_context__.v({
  "active": "pacific-supply-map-module__wm6PPG__active",
  "brand": "pacific-supply-map-module__wm6PPG__brand",
  "brandIcon": "pacific-supply-map-module__wm6PPG__brandIcon",
  "callout": "pacific-supply-map-module__wm6PPG__callout",
  "callouts": "pacific-supply-map-module__wm6PPG__callouts",
  "card": "pacific-supply-map-module__wm6PPG__card",
  "cardHeader": "pacific-supply-map-module__wm6PPG__cardHeader",
  "china": "pacific-supply-map-module__wm6PPG__china",
  "draw": "pacific-supply-map-module__wm6PPG__draw",
  "headerNote": "pacific-supply-map-module__wm6PPG__headerNote",
  "marker": "pacific-supply-map-module__wm6PPG__marker",
  "node": "pacific-supply-map-module__wm6PPG__node",
  "ocean": "pacific-supply-map-module__wm6PPG__ocean",
  "place": "pacific-supply-map-module__wm6PPG__place",
  "rise": "pacific-supply-map-module__wm6PPG__rise",
  "route": "pacific-supply-map-module__wm6PPG__route",
  "routeHalo": "pacific-supply-map-module__wm6PPG__routeHalo",
  "show": "pacific-supply-map-module__wm6PPG__show",
  "stage": "pacific-supply-map-module__wm6PPG__stage",
  "steps": "pacific-supply-map-module__wm6PPG__steps",
  "travel": "pacific-supply-map-module__wm6PPG__travel",
  "usa": "pacific-supply-map-module__wm6PPG__usa",
  "worldMap": "pacific-supply-map-module__wm6PPG__worldMap",
});
